import { c as _c } from "react/compiler-runtime";
import React, { type CSSProperties } from 'react';
import { AVATAR_CLASS_NAME } from '../classNames';
import { StyledImage, StyledAvatar, StyledLabel } from './styles';
import { type AvatarProps } from './types';
export function convertLabel(label: string): string {
  if (label.length > 1) {
    return label.substring(0, 1);
  }
  return label;
}
const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>((t0, ref) => {
  const $ = _c(38);
  let T0;
  let disabled;
  let imageUrl;
  let kind;
  let number;
  let objectFit;
  let onError;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== ref || $[1] !== t0) {
    const {
      size,
      kind: t9,
      onError: t10,
      className,
      ...props
    } = t0;
    kind = t9;
    onError = t10;
    disabled = "disabled" in props ? props.disabled ?? false : false;
    const backgroundColor = "backgroundColor" in props ? props.backgroundColor : undefined;
    const label = "label" in props ? props.label : undefined;
    imageUrl = "imageUrl" in props ? props.imageUrl : undefined;
    objectFit = "objectFit" in props ? props.objectFit ?? "fill" : "fill";
    number = "number" in props ? props.number : undefined;
    const {
      disabled: _disabled,
      backgroundColor: _backgroundColor,
      label: _label,
      imageUrl: _imageUrl,
      objectFit: _objectFit,
      number: _number,
      ...hostProps
    } = props as typeof props & {
      disabled?: boolean;
      backgroundColor?: string;
      label?: string;
      imageUrl?: string;
      objectFit?: CSSProperties['objectFit'];
      number?: string;
    };
    T0 = StyledAvatar;
    t1 = hostProps;
    t2 = size ?? "medium";
    t3 = kind;
    t4 = className != null && className !== "" ? `${AVATAR_CLASS_NAME} ${className}` : AVATAR_CLASS_NAME;
    t5 = backgroundColor;
    t6 = ref;
    t7 = disabled;
    t8 = kind === "label" && <StyledLabel $disabled={disabled}>{convertLabel(label ?? "")}</StyledLabel>;
    $[0] = ref;
    $[1] = t0;
    $[2] = T0;
    $[3] = disabled;
    $[4] = imageUrl;
    $[5] = kind;
    $[6] = number;
    $[7] = objectFit;
    $[8] = onError;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    T0 = $[2];
    disabled = $[3];
    imageUrl = $[4];
    kind = $[5];
    number = $[6];
    objectFit = $[7];
    onError = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== imageUrl || $[18] !== kind || $[19] !== objectFit || $[20] !== onError) {
    t9 = kind === "image" && <StyledImage src={imageUrl ?? ""} $objectFit={objectFit} onError={onError} />;
    $[17] = imageUrl;
    $[18] = kind;
    $[19] = objectFit;
    $[20] = onError;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== disabled || $[23] !== kind || $[24] !== number) {
    t10 = kind === "number" && <StyledLabel $kind={kind} $disabled={disabled}>{number != null ? number : ""}</StyledLabel>;
    $[22] = disabled;
    $[23] = kind;
    $[24] = number;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t10 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t11 = <T0 {...t1} $size={t2} $kind={t3} className={t4} $backgroundColor={t5} ref={t6} $disabled={t7}>{t8}{t9}{t10}</T0>;
    $[26] = T0;
    $[27] = t1;
    $[28] = t10;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
});
export default Avatar;
export { Avatar };